import { useRef } from 'react'

import { useApolloClientWithAuth } from '@flowwai-frontend/shared/auth/common'

import { UserServiceAPI } from '../../services/UserService/index.api'

const useUserService = (): UserServiceAPI => {
   const client = useApolloClientWithAuth()
   const userServiceRef = useRef(new UserServiceAPI(client))

   return userServiceRef.current
}

export { useUserService }
